/// <amd-module name="SuiteCommerce.SizeChart.Chart.Page.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.SizeChart.Chart.Page.Model", ["require", "exports", "Backbone", "SuiteCommerce.SizeChart.Chart.Collection", "SuiteCommerce.SizeChart.Common.Utils"], function (require, exports, Backbone_1, Chart_Collection_1, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ChartPageModel = /** @class */ (function (_super) {
        __extends(ChartPageModel, _super);
        function ChartPageModel(options) {
            return _super.call(this, options) || this;
        }
        Object.defineProperty(ChartPageModel.prototype, "charts", {
            get: function () {
                if (!this.get('charts')) {
                    this.charts = new Chart_Collection_1.ChartCollection();
                }
                return this.get('charts');
            },
            set: function (charts) {
                this.set('charts', charts);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ChartPageModel.prototype, "isRenderedInModal", {
            get: function () {
                return this.get('isRenderedInModal');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ChartPageModel.prototype, "sizeChartSearchKey", {
            get: function () {
                return this.get('sizeChartSearchKey');
            },
            enumerable: true,
            configurable: true
        });
        ChartPageModel.prototype.getPageTitle = function () {
            if (this.sizeChartSearchKey && this.charts.size() > 0) {
                return this.charts.at(0).title;
            }
            return Utils_1.Utils.translate('Size Charts');
        };
        ChartPageModel.prototype.getSizeChartId = function () {
            if (this.sizeChartSearchKey && this.charts.size() > 0) {
                return this.charts.at(0).internalId;
            }
            return;
        };
        return ChartPageModel;
    }(Backbone_1.Model));
    exports.ChartPageModel = ChartPageModel;
});
